import { useMemo } from "react"
import { useGetProjectCategoriesQuery } from "pages/Common/commonService"

type DropdownOption = { id: number; title: string }

type Options = {
    /**
     * Filter drawers pass true. System categories are written only by automations and cannot be
     * picked on a raise form, but they have to stay selectable as a filter or that volume becomes
     * unreportable. Raise-form pickers leave this off.
     */
    includeSystem?: boolean
    /**
     * Filter drawers pass true so a deactivated category still renders on the projects that carry
     * it. Inactive options are suffixed so it is obvious why they are not offered on raise forms.
     */
    includeInactive?: boolean
    skip?: boolean
}

/**
 * Dropdown options for the project category master, ordered by the backend's sort_order.
 */
const useProjectCategoryOptions = ({ includeSystem, includeInactive, skip }: Options = {}) => {
    const { data, isFetching } = useGetProjectCategoriesQuery(
        { include_system: includeSystem, include_inactive: includeInactive },
        { skip }
    )

    const options = useMemo<DropdownOption[]>(
        () =>
            (data ?? []).map(category => ({
                id: category.category_id,
                title: category.is_active ? category.category_name : `${category.category_name} (Inactive)`,
            })),
        [data]
    )

    return { options, categories: data ?? [], isFetching }
}

export default useProjectCategoryOptions
